import antdJaJP from 'antd/es/locale/ar_EG';
import axios from "axios";
import { env } from 'configs/EnvironmentConfig';

const fetchMessages = async () => {
  const response = await axios.get(process.env.NODE_ENV === 'production' ? env.IMG_SRC + '/locales/ar_TN.json' : 'https://apitest.tunimobile.com/locales/ar_TN.json'); // Replace with your URL
  if (response.status !== 200) {
    throw new Error(`Failed to load translations: ${response.statusText}`);
  }
  return await response.data;
};
const ArLang = {
  antd: antdJaJP,
  locale: 'ar',
  fetchMessages
};
export default ArLang;